import { render } from "./PremiumCalculationBpmCollapse.vue?vue&type=template&id=3cb21e57&scoped=true"
import script from "./PremiumCalculationBpmCollapse.vue?vue&type=script&lang=js"
export * from "./PremiumCalculationBpmCollapse.vue?vue&type=script&lang=js"

import "./PremiumCalculationBpmCollapse.vue?vue&type=style&index=0&id=3cb21e57&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb21e57"]])

export default __exports__